var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "app-header d-flex justify-content-between align-items-center"
    },
    [
      _vm.env != "production"
        ? _c("div", { staticClass: "badge badge-light env-badge" }, [
            _vm._v(_vm._s(_vm.env) + " Server")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "nav-right" }, [
        _c("div", { staticClass: "user-nav" }, [
          _c("div", { staticClass: "user-details" }, [
            _c("span", { staticClass: "username" }, [
              _vm._v(_vm._s(_vm.getUserName))
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb50a5e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb50a5e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = vVBX
// module chunks = 1